/* src/app/groups/presenters/groups-add/groups-add.component.scss */
#groupAddDialog {
  width: 40vw;
  height: 40vh;
}
#groupAddDialog mat-dialog-content {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
#groupAddDialog mat-dialog-content > form > label {
  font-size: large;
  font-weight: bold;
}
.p-float-label textarea:focus ~ label,
.p-float-label textarea.p-state-filled ~ label {
  top: -0.75rem;
  font-size: 12px;
}
/*# sourceMappingURL=groups-add.component.css.map */
